import { WarningOutlined } from "@ant-design/icons";
import { Spacing } from "@p0security/ui";
import { GraphTooltip } from "components/GraphTooltip";

export const PolicyChangeWarning: React.FC = () => (
  <GraphTooltip title="Changes to access policies do not revoke existing access. They only apply to future requests.">
    <Spacing asChild ml={8}>
      <WarningOutlined />
    </Spacing>
  </GraphTooltip>
);
